/*
 *
 * SearchForm
 *
 */

import { UploadOutlined } from "@ant-design/icons";
import { Button, Image, message, Modal } from "antd";
import { useState } from "react";

import CustomMediaImageSelectModal from "./CustomMediaImageSelectModal";

const CustomImageUploadToMedia = ({
  value = "",
  uploadUrl,
  changeImageBtnText,
  optType,
  onChange,
  onLoadingState,
  rawdata,
  multiple,
}: any) => {
  const [messageApi, contextHolder]: any = message.useMessage();
  const [upLoading, setUpLoading]: any = useState(false);
  const [open, setOpen]: any = useState(false);
  const triggerChange = (changedValue: any) => {
    if (onChange) {
      onChange(changedValue);
    }
  };

  const showModal = () => {
    setOpen(true);
  };
  const handleOk = () => {};
  const handleCancel = () => {
    setOpen(false);
  };
  const onImgsSelect = (e: any) => {
    triggerChange(e);
    setOpen(false);
    // console.log(e, "onImgsSelect");
  };

  // return <Input value={value} onChange={(e) => triggerChange(e.target.value)} />;
  return (
    <>
      {contextHolder}
      {["Edit", "Add"].includes(optType) ? (
        // <Upload
        //   beforeUpload={(event) => handleBeforeUpload(event, rawdata.dataIndex)}
        //   showUploadList={false}
        // >
        //   <Button
        //     loading={upLoading}
        //     disabled={upLoading || rawdata.disabledEdit}
        //     icon={<UploadOutlined />}
        //   >
        //     {upLoading ? "Up Loading" : changeImageBtnText || "Change Image"}
        //   </Button>
        // </Upload>
        <Button
          onClick={showModal}
          loading={upLoading}
          disabled={upLoading || rawdata.disabledEdit}
          icon={<UploadOutlined />}
        >
          {upLoading ? "Up Loading" : changeImageBtnText || "Change Image"}
        </Button>
      ) : (
        ""
      )}
      {value ? (
        <div style={{ maxWidth: rawdata.maxWidth || 150 }}>
          <Image
            style={{ marginTop: "5px" }}
            width={"100%"}
            src={typeof value === "string" ? value : value.url}
          />
        </div>
      ) : (
        ""
      )}
      {open && (
        <Modal
          maskClosable={false}
          onCancel={handleCancel}
          title="Add new assets"
          width={800}
          open={open}
          footer={null}
        >
          <CustomMediaImageSelectModal
            multiple={multiple}
            onCancel={handleCancel}
            onChange={onImgsSelect}
          />
        </Modal>
      )}
    </>
  );
};

export default CustomImageUploadToMedia;
